import React, { FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { FilterName } from '../../../../constants/FilterName';
import { useSourceNameTranslationId } from '../../../../utils/media-manager-sdk/root-folder';
import { getActiveItemFilter } from '../../../../utils/publicMedia';
import { IOuter } from '../EmptyState.types';

export const SearchBySourceTitle: FC<IOuter> = ({ itemsFilters, searchQuery, source }) => {
  const sourceNameTranslationId = useSourceNameTranslationId(source);

  const filterName = useMemo(() => {
    if (itemsFilters && itemsFilters.length) {
      const activeItemFilter = getActiveItemFilter(itemsFilters, FilterName.Category);
      return activeItemFilter && activeItemFilter.name;
    }

    return null;
  }, [itemsFilters]);

  return (
    <FormattedMessage
      id="empty-state.search-by-source-title"
      values={{
        searchQuery,
        sourceName: filterName || <FormattedMessage id={sourceNameTranslationId} />,
      }}
    />
  );
};
